<template>
  <el-aside
    v-if="routes.length"
    class="sidebar"
    style="
      display: flex;
      flex-direction: column;
      background-color: #fff;
      transition: width 0.5s;
      height: 100%;
      border-right: 1px solid #dcdfe6;
      width: inherit;
    "
    :class="{ collapse: isCollapse }"
  >
    <slot name="sidebar-top"></slot>
    <el-scrollbar style="padding-right: 10px">
      <el-menu
        :collapse="isCollapse"
        :unique-opened="false"
        :default-openeds="[routes[0].path]"
        :default-active="activeMenu"
        mode="vertical"
        style="
          flex: 1;
          overflow: auto;
          position: relative;
          width: 100%;
          border: none;
          padding: 0 5px;
          user-select: none;
          overflow: hidden !important;
        "
        :class="['menu', isCollapse && 'ext']"
        @select="selectMenu"
      >
        <SideBarItem
          v-for="routeItem in routes"
          :key="routeItem.path"
          :item="routeItem"
          :base-path="routeItem.path"
          :is-collapse="isCollapse"
          is-first-level
        />
      </el-menu>
    </el-scrollbar>
    <slot name="sidebar-bottom"></slot>
  </el-aside>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'
import useAppStore from '@shared/store/useAppStore'
import SideBarItem from './SideBarItem.vue'
import { isExternal } from '@shared/utils/validate'
import { cloneDeep } from 'lodash-es'

const router = useRouter()
const route = useRoute()
const appStore = useAppStore()

const isCollapse = computed(() => !appStore.sidebar.opened)

/** 需要展示在左侧导航的路由 */
const routes = computed(() => {
  if (!appStore.activeSystemItem || appStore.activeSystemItem.hiddenSideBar) {
    return []
  }
  const r = filterHidden(cloneDeep(appStore.activeSystemItem.routes))
  console.log(r, 'rrrrrrrrr')
  return r
})

const filterHidden = (list) => {
  return list
    .filter((r) => {
      return !r.meta?.hidden
    })
    .filter((r) => {
      // 过滤三级菜单为空的数据 水环境 -> 数据分析
      return JSON.stringify(r.children) !== '[]'
    })
    .map((i) => {
      if (i.children?.length) {
        i.children = filterHidden(i.children)
      }
      return i
    })
    .filter((r) => {
      // 过滤二级菜单为空的数据 水环境 -> 数据分析
      return JSON.stringify(r.children) !== '[]'
    })
}

/** 判断是否为激活路由 */
const activeMenu = computed(() => {
  const { meta, path } = route
  if (meta !== null || meta !== undefined) {
    if (meta.activeMenu) {
      return meta.activeMenu
    }
  }
  return path
})

const selectMenu = (path) => {
  if (router.currentRoute.value.fullPath === path) return

  if (isExternal(path)) {
    window.open(path)
  } else {
    router.push(path)
  }
}
</script>

<style scoped lang="scss">
.sidebar {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  transition: width 0.5s;
  height: 100%;
  border-right: 1px solid #dcdfe6;
  width: inherit;

  &.collapse {
    width: 54px;
  }
}

.menu {
  position: relative;
  width: 100%;
  border: none;
  padding: 0 5px;
  user-select: none;
  overflow: hidden !important;

  :deep() {
    .el-sub-menu__title {
      border-radius: 8px;
      &:hover {
        color: #1890ff !important;
        .menu-icon {
          fill: #1890ff !important;
        }
      }
    }

    .el-menu-item {
      display: flex;
      align-items: center;
      border-radius: 8px;
      text-indent: 10px;

      &.is-active {
        .menu-icon {
          fill: #1890ff !important;
        }
      }

      &:hover {
        color: #1890ff !important;

        .menu-icon {
          fill: #1890ff !important;
        }
      }

      * {
        vertical-align: baseline;
      }
    }
  }
}

.ext {
  :deep() {
    .el-sub-menu__title,
    .el-menu-tooltip__trigger {
      justify-content: center !important;
    }
  }
}
</style>
